<template>

    <div class="my-5 w-full">  
      <button
       class="flex items-center px-5 py-2 rounded-md  border border-gray-100 bg-gray-400 text-gray-600"
        @click.prevent='pickFile'
        :loading="uploadingImage"
        :disabled="uploadingImage"
      >
      <svg class="w-6 h-6 text-white mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
        </svg>
        <span class="text-sm leading-tight">{{$t('Subir Fichero')}}</span>
      </button>
      <!-- accept="image/*,application/pdf" -->
      <input
        type="file"
        style="display: none"
        ref="image"
        :accept="accept"
        @change="onFilePicked"
      >
      <div class="my-5" v-if="imageUrl">
        <div v-if="datosFile">
                  <div v-if="datosFile.extension != 'pdf'">
          <img :src="imageUrl" alt="imagen">
        </div>
        <div v-else>
          PDF
        </div>
        </div>
        
        <div class="text-red-600 text-xs font-bold my-2" v-if="!valido">
          {{$t('Fichero no valido')}} <br>
          {{$t('Tamaño')}}: {{fileSize}}
        </div>
        <!-- <div else>
          fichero valido
          <pre>
            {{datosFile}}
          </pre>
        </div> -->
        <div class="my-5" v-if="datosFile" >
          <div v-if="uploadingImage">
            {{$t('subiendo')}} {{uploadProgress}}
          </div>
           <button @click.prevent="enviar(datosFile)" class="px-5 py-2 w-full bg-blue-600 text-white bold uppercase text-sm ">{{$t('guardar')}}</button>
        </div>
       

      </div>
    </div>
</template>
<script>
export default {
  props:['carpeta','tipo','imageId','nombre','accept','max','ventana'],
  data: () => ({
    title: "Image Upload",
    dialog: false,
    imageName: "",
    imageUrl: "",
    imageFile: "",
    datosFile: null,
    fileSize: 0,
    valido: false
  }),
  computed: {
    uploadingImage(){
      return this.$store.state.uploadingImage
    },
    uploadProgress(){
      return this.$store.state.uploadProgress
    }
  },
  methods: {
    pickFile() {
      this.$refs.image.click();
    },
    enviar(datos) {
        this.$store.dispatch('uploadImage', datos).then(doc=>{
      // cl*('ha llegado cerrarVentna', this.ventana)
          this.$emit('cerrar', this.ventana)
        })
    },
    onFilePicked(e) {
      // var storageRef = storage.ref().child('img/recintos').child(place_id).child(name).put(fichero);

      const files = e.target.files;
  // cl*('fichero',e)
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
            const carpeta = this.carpeta
            const tipo = this.tipo
            const nombre = this.nombre
            const imageId = this.imageId

          var re = /(?:\.([^.]+))?$/;
          this.imageUrl = fr.result;
          this.fichero = files[0]; // this is an image file that can be sent to server...
          const fichero = files[0]
          const extension = re.exec(fichero.name)[1]
          const fileName = nombre+ '__' + tipo + '.' + extension.toLowerCase()
          const formato = files[0].type
          const max = Number(this.max)
          this.fileSize = fichero.size
          const datos = {
            carpeta,
            tipo,
            nombre,
            fichero,
            fileName,
            extension,
            imageId,
            formato
          }
      // cl*('datos', datos, 'dosTres', this.imageUrl)
          if (fichero.size > max) {
            this.valido = false
          } else {
            this.valido = true
            this.datosFile = datos
          }
          
          // this.$store.dispatch('uploadImage', datos)
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    }
  }
};
</script>
